(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fn-sign-customiser"] && !Shopify.designMode) return;
  try {
    
  (() => {
    let initialized = false;
    const initialize = () => {
      if (initialized || !document.querySelector('.fn-sign-customiser-section')) return;
      initialized = true;

    const marker = 'fn-sign-customiser';
    const previews = new Map();
    let edgeFrame = 0;
    const fitPreviews = () => {
      edgeFrame = 0;
      const enabled = Boolean(document.querySelector('.fn-sign-customiser-section'));
      const viewport = window.visualViewport;
      const left = (viewport?.offsetLeft || 0) + 12;
      const right = (viewport?.offsetLeft || 0) + Math.min(viewport?.width || document.documentElement.clientWidth, document.documentElement.clientWidth) - 12;
      for (const [preview, state] of previews) {
        if (!preview.isConnected || !enabled) {
          state.observer.disconnect();
          previewResizeObserver.unobserve(preview);
          preview.style.removeProperty('--fn-preview-shift');
          preview.removeAttribute('data-fn-edge-shifted');
          previews.delete(preview);
          continue;
        }
        const rect = preview.getBoundingClientRect();
        if (!rect.width) continue;
        const baseLeft = rect.left - state.shift;
        const shift = Math.max(left - baseLeft, Math.min(0, right - (baseLeft + rect.width)));
        if (Math.abs(shift - state.shift) > 0.5) {
          state.shift = shift;
          preview.style.setProperty('--fn-preview-shift', shift + 'px');
          preview.toggleAttribute('data-fn-edge-shifted', Math.abs(shift) > 0.5);
        }
      }
    };
    const scheduleEdges = () => {
      if (!edgeFrame) edgeFrame = requestAnimationFrame(fitPreviews);
    };
    const previewResizeObserver = new ResizeObserver(scheduleEdges);
    const watchPreview = (preview) => {
      if (previews.has(preview)) return;
      const observer = new MutationObserver(scheduleEdges);
      if (preview.parentElement) observer.observe(preview.parentElement, { attributes: true, attributeFilter: ['style'] });
      previews.set(preview, { shift: 0, observer });
      previewResizeObserver.observe(preview);
      scheduleEdges();
    };
    const syncWidth = () => {
      const width = document.documentElement.clientWidth + 'px';
      document.querySelectorAll('.fn-sign-customiser-section').forEach((section) => {
        section.style.setProperty('--fn-viewport-width', width);
        const container = section.querySelector(':scope > .fn-sign-customiser');
        if (!container) return;
        if (container.dataset.fnFullWidth !== 'true') {
          container.style.removeProperty('--fn-breakout-left');
          return;
        }
        const margin = parseFloat(getComputedStyle(container).marginLeft) || 0;
        const offset = margin - container.getBoundingClientRect().left;
        container.style.setProperty('--fn-breakout-left', offset + 'px');
      });
    };
    const widthObserver = new ResizeObserver(syncWidth);
    widthObserver.observe(document.documentElement);
    const syncPortal = (portal) => {
      const enabled = Boolean(document.querySelector('.fn-sign-customiser-section'));
      if (portal.classList.contains(marker) !== enabled) portal.classList.toggle(marker, enabled);
      portalObserver.observe(portal, { attributes: true, attributeFilter: ['class'] });
      if (enabled && portal.matches('.npc-hover-image-content')) watchPreview(portal);
    };
    const portalObserver = new MutationObserver((records) => {
      for (const record of records) syncPortal(record.target);
    });
    const syncPortals = () => {
      syncWidth();
      document.querySelectorAll('.npc-portal').forEach(syncPortal);
      scheduleEdges();
    };
    const observer = new MutationObserver((records) => {
      for (const record of records) {
        for (const node of record.addedNodes) {
          if (!(node instanceof Element)) continue;
          if (node.matches('.npc-portal')) syncPortal(node);
          node.querySelectorAll('.npc-portal').forEach(syncPortal);
        }
      }
      if (previews.size) scheduleEdges();
    });
    observer.observe(document.body, { childList: true, subtree: true });
    window.addEventListener('resize', syncWidth, { passive: true });
    window.addEventListener('resize', scheduleEdges, { passive: true });
    document.addEventListener('scroll', scheduleEdges, { passive: true, capture: true });
    window.visualViewport?.addEventListener('resize', scheduleEdges, { passive: true });
    window.visualViewport?.addEventListener('scroll', scheduleEdges, { passive: true });
    document.addEventListener('shopify:section:load', syncPortals);
    document.addEventListener('shopify:section:unload', () => requestAnimationFrame(syncPortals));
    syncPortals();
    };
    document.addEventListener('shopify:section:load', initialize);
    initialize();
  })();

  } catch(e) { console.error(e); }
})();
})();
